export const DYNAMIC_CLIENT_FREQUENCY_CATMAN_KPIS = [
    'cardholder_frequency_lost_previous',
    'cardholder_frequency_lost_in_brand_only_previous',
    'cardholder_frequency_lost_in_category_for_you_previous',
    'cardholder_frequency_lost_to_category_all_competitors_previous',
    'cardholder_frequency_regular',
    'cardholder_frequency_regular_previous',
    'cardholder_frequency_new',
    'cardholder_frequency_new_in_brand_only',
    'cardholder_frequency_new_in_category_for_you',
    'cardholder_frequency_new_to_category_all_competitors',
    'cardholder_frequency_by_movement',
    'cardholder_frequency_by_movement_evolution'
];
export const DYNAMIC_CLIENT_FREQUENCY_KPI_DISPLAY_NAME = [
    'dynamic_client_cardholder_frequency_lost_previous',
    'dynamic_client_cardholder_frequency_lost_in_brand_only_previous',
    'dynamic_client_cardholder_frequency_lost_in_category_for_you_previous',
    'dynamic_client_cardholder_frequency_lost_to_category_all_competitors_previous',
    'dynamic_client_cardholder_frequency_regular',
    'dynamic_client_cardholder_frequency_regular_previous',
    'dynamic_client_cardholder_frequency_new',
    'dynamic_client_cardholder_frequency_new_in_brand_only',
    'dynamic_client_cardholder_frequency_new_in_category_for_you',
    'dynamic_client_cardholder_frequency_new_to_category_all_competitors',
    'cardholder_frequency_by_movement',
    'cardholder_frequency_by_movement_comparison',
    'cardholder_frequency_by_movement_benchmark'
];
export const DYNAMIC_CLIENT_FREQUENCY_KPI_MAPPING = {
    dynamic_client_cardholder_frequency_lost_previous: 'cardholder_frequency_lost_previous',
    dynamic_client_cardholder_frequency_lost_in_brand_only_previous: 'cardholder_frequency_lost_in_brand_only_previous',
    dynamic_client_cardholder_frequency_lost_in_category_for_you_previous: 'cardholder_frequency_lost_in_category_for_you_previous',
    dynamic_client_cardholder_frequency_lost_to_category_all_competitors_previous: 'cardholder_frequency_lost_to_category_all_competitors_previous',
    dynamic_client_cardholder_frequency_regular: 'cardholder_frequency_regular',
    dynamic_client_cardholder_frequency_regular_previous: 'cardholder_frequency_regular_previous',
    dynamic_client_cardholder_frequency_new: 'cardholder_frequency_new',
    dynamic_client_cardholder_frequency_new_in_brand_only: 'cardholder_frequency_new_in_brand_only',
    dynamic_client_cardholder_frequency_new_in_category_for_you: 'cardholder_frequency_new_in_category_for_you',
    dynamic_client_cardholder_frequency_new_to_category_all_competitors: 'cardholder_frequency_new_to_category_all_competitors',
    cardholder_frequency_by_movement: 'cardholder_frequency_by_movement',
    cardholder_frequency_by_movement_comparison: 'cardholder_frequency_by_movement_evolution',
    cardholder_frequency_by_movement_benchmark: 'cardholder_frequency_by_movement_evolution'
};
export const DYNAMIC_CLIENT_FREQUENCY_DATA_TABLE_KPI_DISPLAY_NAME = [
    'cardholder_frequency_by_movement',
    'cardholder_frequency_by_movement_comparison',
    'cardholder_frequency_by_movement_benchmark'
];
//# sourceMappingURL=frequency.kpis.js.map